import { getStripeAccountId, hasStripeAccountConflict, paymentProcessor } from './paymentReadiness';

export const STRIPE_REVIEW_PATH = '/settings/compliance';
export const OPEN_ORGANIZATION_PICKER = 'charitystack:open-organization-picker';
const INTENTS = ['requirements', 'account-management', 'choose'];
// Stripe reserves query parameters beginning with stripe_ in saved site links.
const REVIEW_PARAM = 'cs_review';
const LEGACY_REVIEW_PARAM = 'stripe_review';

/** The only persisted redirect information is this allowlisted, non-secret query. */
export function readStripeReviewLink(location) {
  const params = new URLSearchParams(location?.search || '');
  if (!params.has('stripe_account_id') && !params.has(REVIEW_PARAM) && !params.has(LEGACY_REVIEW_PARAM)) return null;
  const accounts = params.getAll('stripe_account_id');
  const intents = [...params.getAll(REVIEW_PARAM), ...params.getAll(LEGACY_REVIEW_PARAM)];
  const path = (location.pathname || '').replace(/^\/dashboard(?=\/|$)/, '').replace(/\/$/, '') || '/';
  // Stripe adds this parameter to payments/payouts links too. Only these review
  // entry points belong to this flow; never hijack other Stripe destinations.
  if (!['/', '/settings', STRIPE_REVIEW_PATH, '/signin', '/onboarding'].includes(path)) return null;
  const intent = intents[0] || (path === '/settings' ? 'choose' : 'requirements');
  if (accounts.length > 1 || intents.length > 1 || !INTENTS.includes(intent)
    || (accounts.length && !/^acct_[A-Za-z0-9]{1,128}$/.test(accounts[0]))) return { invalid: true };
  return { accountId: accounts[0] || '', intent };
}

export function stripeReviewSearch(link) {
  if (!link) return '';
  if (link.invalid) return `?${REVIEW_PARAM}=invalid`;
  const params = new URLSearchParams({ [REVIEW_PARAM]: link.intent });
  if (link.accountId) params.set('stripe_account_id', link.accountId);
  return `?${params}`;
}

export function stripeReviewReturnPath(location, fallback = '/') {
  const link = readStripeReviewLink(location);
  return link ? STRIPE_REVIEW_PATH + stripeReviewSearch(link) : fallback;
}

export function stripeReviewMatches(link, merchant, activeOrgId) {
  return Boolean(link && !link.invalid && link.accountId && activeOrgId
    && merchant?.clerkOrganizationId === activeOrgId
    && !hasStripeAccountConflict(merchant) && paymentProcessor(merchant) === 'STRIPE'
    && getStripeAccountId(merchant) === link.accountId);
}

/** A different workspace's checkout must not swallow an incoming Stripe link. */
export function stripeReviewNeedsOrganizationSelection({ subscriptionRequired, link, merchant, activeOrgId }) {
  return Boolean(subscriptionRequired && link && !stripeReviewMatches(link, merchant, activeOrgId));
}
